import React from "react"

import * as styles from "./styles.module.scss"

const CommonHead = ({ children, appendClass }) => {
  return <h1 className={`${styles.common_head} ${appendClass}`}>{children}</h1>
}

export default CommonHead
